var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61145 1.69062C9.30554 0.303314 11.3021 0.303315 11.9962 1.69062L13.9532 5.60078L18.3341 6.22871C19.8731 6.44912 20.5135 8.33227 19.379 9.42402V9.425L16.214 12.465L16.9611 16.758C17.2296 18.3061 15.5908 19.4431 14.2228 18.7336L10.3038 16.7023L6.38391 18.7326L6.38489 18.7336C5.01678 19.4431 3.37807 18.306 3.64661 16.758H3.64758L4.3927 12.465L1.22961 9.425C0.0927631 8.33351 0.736126 6.45027 2.27356 6.22871L6.65344 5.60078L8.61145 1.69062Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavWhite);
export default __webpack_public_path__ + "static/media/fav-white.ebf64ebce4d456255c7eec9aa548d699.svg";
export { ForwardRef as ReactComponent };